import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openNotificationModal } from 'base/actions/notificationModals';
import { MENU_HOURS_EXPIRED } from 'cart/constants/notificationTypes';

import { checkIfCurrentMenuIsExpired } from 'menus/actions';

class LaunchNotificationOnMount extends React.Component {
  static propTypes = {
    handleCallback: PropTypes.func,
    dispatch: PropTypes.func
  };

  static defaultProps = {
    handleCallback: () => {}
  };

  componentDidMount() {
    this.checkIfMenuExpired();
  }

  checkIfMenuExpired() {
    const isExpired = this.props.dispatch(checkIfCurrentMenuIsExpired());
    if (isExpired) {
      this.props.handleCallback();
      this.props.dispatch(openNotificationModal(MENU_HOURS_EXPIRED));
    }
  }

  render() {
    return null;
  }
}

export default connect()(LaunchNotificationOnMount);
